export const selectProducts = (state) => state.products;
